import React from "react";
import Second from "./Second_section/Second";
import Third from "./Third_section/Third";
import Technology from "../../Home/Technologystack/Technology";
import Fourth from "../MobileApp/Fourth_section/Fourth";
import Last from "./Last_section/Last";
import Blog from "./Blog/Blog";

const Extra = () => {
  return (
    <>
      <Second />
      <Third />
      <Technology />
      <Fourth />
      <Last />
      <Blog />
    </>
  );
};

export default Extra;
